import { render, staticRenderFns } from "./commission_check.vue?vue&type=template&id=b418dcd6&scoped=true"
import script from "./commission_check.vue?vue&type=script&lang=js"
export * from "./commission_check.vue?vue&type=script&lang=js"
import style0 from "./commission_check.vue?vue&type=style&index=0&id=b418dcd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b418dcd6",
  null
  
)

export default component.exports